import React, { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  TableSortLabel,
  useTheme,
  TableCell,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Link, useNavigate } from "react-router-dom";
import AppTableRowCell from "../common/pages/AppTableRowCell";
import {
  CustomMenu,
  CustomMenuItem,
  StyledTableRow,
} from "../../../styles/Shipmentstyles";
import AppTableHeaderCell from "../common/pages/AppTableHeaderCell";
import { Customer } from "../../../models/Customer/Customer";
import AppTablePagenation from "../common/pages/AppTablePagenation";
import { SortType } from "../../../models/SortType";
import { useStores } from "../../../use-stores";
import { EmployeeRoles } from "../../../models/Employees/EmployeeRoles";
interface CustomerTableProp {
  maxHeight: number;
  customers: Customer[];
  limit: number;
  page_no: number;
  total_pages: number;
  total_count: number;
  sortBy: string;
  onDelete: (custormerId: number) => void;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  onRowsPerPageChange: (limit: number) => void;
  sortType: SortType;
  onSortChange: (column: string, sortType: SortType) => void;
}

const CustomerTable = ({
  maxHeight,
  customers,
  page_no,
  limit,
  total_pages,
  total_count,
  sortBy,
  onPageChange,
  onRowsPerPageChange,
  onDelete,
  sortType,
  onSortChange,
}: CustomerTableProp) => {
  let navigate = useNavigate();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedId] = useState<number[]>([]);
  const [currentCustomerId, setCurrentCustomerId] = useState<number | null>(
    null
  );

  const isOpen = Boolean(anchorEl);
  const { userStore } = useStores();
  const handleMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    currentCustomerId: number
  ) => {
    setAnchorEl(event.currentTarget);
    setCurrentCustomerId(currentCustomerId);
  };

  const handleEdit = () => {
    if (currentCustomerId)
      navigate("/customers/add-edit-customer?customer-id=" + currentCustomerId);
  };

  const handleDelete = () => {
    if (currentCustomerId !== null) {
      onDelete(currentCustomerId);
    }
    handleMenuClose();
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentCustomerId(null);
  };

  const handleRowsChange = (value: number) => {
    onPageChange(null, 1);
    onRowsPerPageChange(value);
  };

  const renderSortIcon = (property: string) => {
    if (sortBy === property) {
      return sortType === SortType.ASC ? "↑" : "↓";
    }
    return "↑↓";
  };

  const isViewOnly = (): boolean => {
    return userStore.hasPermission(EmployeeRoles.VIEW_CUSTOMER) && 
           !userStore.hasPermission(EmployeeRoles.EDIT_CUSTOMER) &&
           !userStore.hasPermission(EmployeeRoles.CREATE_CUSTOMER);
  };

  const rowClickable = (): boolean =>{
    return userStore.hasPermission(EmployeeRoles.VIEW_CUSTOMER) ||
           userStore.hasPermission(EmployeeRoles.EDIT_CUSTOMER) ||
           userStore.hasPermission(EmployeeRoles.CREATE_CUSTOMER);
  }

  return (
    <>
      <Paper sx={{ marginTop: "0.6rem" }}>
        {selectedId?.length > 0 && (
          <Typography sx={{ paddingLeft: 2, paddingTop: 1 }}>
            {`Selected - ` + selectedId?.length}
          </Typography>
        )}

        <TableContainer sx={{ maxHeight: window.innerHeight - 340 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <AppTableHeaderCell
                  sx={{
                    padding: "6px 12px",
                    position: "sticky",
                    left: 0,
                    zIndex: 12,
                    boxShadow: "10px 0 20px -12px rgba(115,115,115,0.3);",
                  }}
                >
                  <TableSortLabel
                    active={sortBy === "id"}
                    direction={sortType === SortType.ASC ? "asc" : "desc"}
                    onClick={() =>
                      onSortChange(
                        "id",
                        sortType === SortType.DESC
                          ? SortType.ASC
                          : SortType.DESC
                      )
                    }
                    IconComponent={() => <span>{renderSortIcon("id")}</span>}
                    sx={{ fontSize: "12px" }}
                  >
                    Id
                  </TableSortLabel>
                </AppTableHeaderCell>
                <AppTableHeaderCell minWidth="300px">
                  <TableSortLabel
                    active={sortBy === "name"}
                    direction={sortType === SortType.ASC ? "asc" : "desc"}
                    onClick={() =>
                      onSortChange(
                        "name",
                        sortType === SortType.DESC
                          ? SortType.ASC
                          : SortType.DESC
                      )
                    }
                    IconComponent={() => <span>{renderSortIcon("name")}</span>}
                    sx={{ fontSize: "12px" }}
                  >
                    Name
                  </TableSortLabel>
                </AppTableHeaderCell>
                <AppTableHeaderCell title="Zoho ID" fontSize="12px" />
                <AppTableHeaderCell>
                  <TableSortLabel
                    active={sortBy === "createdDate"}
                    direction={sortType === SortType.ASC ? "asc" : "desc"}
                    onClick={() =>
                      onSortChange(
                        "createdDate",
                        sortType === SortType.DESC
                          ? SortType.ASC
                          : SortType.DESC
                      )
                    }
                    IconComponent={() => (
                      <span>{renderSortIcon("createdDate")}</span>
                    )}
                    sx={{ fontSize: "12px" }}
                  >
                    Created Date
                  </TableSortLabel>
                </AppTableHeaderCell>
                <AppTableHeaderCell>
                  <TableSortLabel
                    active={sortBy === "modifiedDate"}
                    direction={sortType === SortType.ASC ? "asc" : "desc"}
                    onClick={() =>
                      onSortChange(
                        "modifiedDate",
                        sortType === SortType.DESC
                          ? SortType.ASC
                          : SortType.DESC
                      )
                    }
                    IconComponent={() => (
                      <span>{renderSortIcon("modifiedDate")}</span>
                    )}
                    sx={{ fontSize: "12px" }}
                  >
                    Modified Date
                  </TableSortLabel>
                </AppTableHeaderCell>
                <AppTableHeaderCell>
                  <TableSortLabel
                    active={sortBy === "modifiedDate"}
                    direction={sortType === SortType.ASC ? "asc" : "desc"}
                    onClick={() =>
                      onSortChange(
                        "modifiedDate",
                        sortType === SortType.DESC
                          ? SortType.ASC
                          : SortType.DESC
                      )
                    }
                    IconComponent={() => (
                      <span>{renderSortIcon("modifiedDate")}</span>
                    )}
                    sx={{ fontSize: "12px" }}
                  >
                    Config Modified Date
                  </TableSortLabel>
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  title="Coupon Redemption Enabled"
                  fontSize="12px"
                />
                <AppTableHeaderCell
                  title="Send Redemption Email"
                  fontSize="12px"
                />
                <AppTableHeaderCell title="Email" fontSize="12px" />
                <AppTableHeaderCell title="From Email Name" fontSize="12px" />
                <AppTableHeaderCell title="Inventory Type" fontSize="12px" />
                <AppTableHeaderCell title="Is Sez" fontSize="12px" />
                <AppTableHeaderCell title="GOC" fontSize="12px" />
                <AppTableHeaderCell title="Campaigns" fontSize="12px" />
                <AppTableHeaderCell title="Swagstore" fontSize="12px" />
                <AppTableHeaderCell title="Shopify" fontSize="12px" />
                <AppTableHeaderCell title="Inventory" fontSize="12px" />
                <AppTableHeaderCell title="Active" fontSize="12px" />
                {(
              (userStore.hasPermission(EmployeeRoles.CREATE_CUSTOMER) ||
              userStore.hasPermission(EmployeeRoles.EDIT_CUSTOMER))) && (
                  <AppTableHeaderCell
                    sx={{
                      textAlign: "center",
                      fontSize: 12,
                      position: "sticky",
                      right: 0,
                      zIndex: 10,
                      backgroundColor: `${theme.palette.background.paper}`,
                    }}
                    title="Actions"
                  />
                )}
              </TableRow>
            </TableHead>
            <TableBody sx={{ padding: "" }}>
              {customers.map((customer: Customer) => {
                return (
                  <>
                   <StyledTableRow
                    key={customer.id}
                    onClick={() => {
                      if (rowClickable() && customer.is_deleted === 0) {
                        navigate(`/customers/add-edit-customer?customer-id=${customer.id}`);
                      }
                    }}
                    sx={{
                      cursor: isViewOnly() ? "" : "pointer",
                    }}
                  >
                      <AppTableRowCell
                        sx={{
                          fontSize: "12px",
                          position: "sticky",
                          left: 0,
                          zIndex: 10,
                          boxShadow: "10px 0 20px -12px rgba(115,115,115,0.3);",
                          backgroundColor: `${theme.palette.background.paper}`,
                        }}
                      >
                        {customer.id}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {customer.name || "NA"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {customer.zoho_id || "NA"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {customer.created_date
                          ? new Date(customer.created_date).toLocaleDateString(
                              "en-GB",
                              {
                                day: "numeric",
                                month: "numeric",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                              }
                            )
                          : "-"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {customer.modified_date
                          ? new Date(customer.modified_date).toLocaleDateString(
                              "en-GB",
                              {
                                day: "numeric",
                                month: "numeric",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                              }
                            )
                          : "-"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {customer?.config?.modified_date
                          ? new Date(
                              customer.config?.modified_date
                            ).toLocaleDateString("en-GB", {
                              day: "numeric",
                              month: "numeric",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                            })
                          : "-"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {Number(customer?.config?.coupon_redemption_enabled) ===
                        0
                          ? "False"
                          : "True"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {Number(customer?.config?.send_redemption_email) === 0
                          ? "False"
                          : "True"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {customer?.config?.email}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {customer?.config?.from_email_name}
                      </AppTableRowCell>
                      <AppTableRowCell>
                      {Number(customer?.config?.inventory_type) === 1
                      ? "Order Level Inventory" 
                      : customer?.config?.inventory_type 
                        ? "Customer Level Inventory" 
                        : "-"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {Number(customer?.config?.is_sez) === 0
                          ? "False"
                          : "True"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {Number(customer?.config?.gift_of_choice_enabled) === 0
                          ? "False"
                          : "True"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {Number(customer?.config?.campaigns_enabled) === 0
                          ? "False"
                          : "True"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {Number(customer?.config?.swagstore_enabled) === 0
                          ? "False"
                          : "True"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {Number(customer?.config?.shopify_enabled) === 0
                          ? "False"
                          : "True"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {Number(customer?.config?.inventory_enabled) === 0
                          ? "False"
                          : "True"}
                      </AppTableRowCell>
                      <AppTableRowCell>
                        {Boolean(!customer.is_deleted) ? "True" : "False"}
                      </AppTableRowCell>
                      {(
              (userStore.hasPermission(EmployeeRoles.CREATE_CUSTOMER) || 
              userStore.hasPermission(EmployeeRoles.EDIT_CUSTOMER))) && !customer.is_deleted && (
                      <TableCell
                        sx={{
                          textAlign: "center",
                          fontSize: 12,
                          width: "10%",
                          position: "sticky",
                          right: 0,
                          zIndex: 8,
                          backgroundColor: `${theme.palette.background.paper}`,
                        }}
                        onClick={(event) => event.stopPropagation()}
                      >
                        <IconButton
                          onClick={(event) => {
                            event.stopPropagation();
                            handleMenuClick(event, Number(customer.id));
                          }}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <CustomMenu
                          onClick={(event) => event.stopPropagation()}
                          anchorEl={anchorEl}
                          open={isOpen}
                          onClose={handleMenuClose}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <CustomMenuItem onClick={() => handleEdit()}>
                            <Link
                              to={`/customers/add-edit-customer?customer-id=${currentCustomerId}`}
                              style={{ textDecoration: "none", color: "black" }}
                            >
                              View/Edit
                            </Link>
                          </CustomMenuItem>
                          {customer.is_deleted === 0 && (
                            <CustomMenuItem onClick={handleDelete}>
                              Delete
                            </CustomMenuItem>
                          )}
                        </CustomMenu>
                      </TableCell>
                       )}
                    </StyledTableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <AppTablePagenation
          fontSize="12px"
          pageNo={page_no}
          limit={limit}
          totalCount={total_count}
          onPageChange={onPageChange}
          handleRowsChange={handleRowsChange}
        />
      </Paper>
    </>
  );
};

export default CustomerTable;
